import { Image, LineClamp } from "@newsela/angelou";
import { useRouter } from "next/router";
import PropTypes from "prop-types";

import PossibleTokens from "@/challenges/PossibleTokens";
import ProgressBarTokensCounter from "@/challenges/ProgressBarTokensCounter";
import TopicMetaRow from "@/challenges/TopicMetaRow";
import ChallengesActivityIcon from "@/icons/ChallengesActivityIcon";
import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";
import {
  ACTIVITIES_CONTENT,
  cardHeaderBackgroundCss,
  challengeDetailCardBadgesContentCss,
  challengeDetailCardBadgesTitleCss,
  challengeDetailCardContentCss,
  challengeDetailCardCss,
  challengeDetailCardTitle,
  challengeDetailHeaderCss,
  descriptionChallengeTextCss,
  finalScoresCss,
  metaCss,
  metaText,
  possibleTokensContainer,
  possibleTokensTeacherHome,
  topicRowCss,
} from "./ChallengeDetailCard.style";

const topicType = {
  topic_id: PropTypes.string,
  title: PropTypes.string,
  image: {
    url: PropTypes.string,
    alt: PropTypes.string,
  },
  description: PropTypes.string,
  total_articles: PropTypes.number,
  total_interactions: PropTypes.number,
  done_interactions: PropTypes.number,
  total_standards: PropTypes.number,
  tokens: PropTypes.number,
  earned_tokens: PropTypes.number,
};

const propTypes = {
  isHomeVersion: PropTypes.bool,
  topic: topicType,
};

const ChallengeDetailCard = ({ isHomeVersion, topic }) => {
  const { data: user } = useUser();
  const userProperties = getUserProperties(user);
  const isTeacher = userProperties.isTeacher;
  const descriptionChallengeText = topic?.description;
  const router = useRouter();
  // const ButtonWithTrackEvent = withTrackEvent(Button);

  const eventProperties = {
    objectType: "User",
    actionName: "Navigate",
    event_type: "click",
    streamProperties: {
      application: "parnassus",
      component_type: "ChallengeDetailCard",
      content_id: topic?.id,
      content_type: "Topic",
      description: "Redirect to Topic Page",
    },
  };

  const topicMetaRockMock = [
    {
      total: topic?.total_articles,
      label: "articles",
    },
    {
      total: topic?.total_interactions,
      label: "activities",
    },
    // ,
    // {
    //   total: topic?.total_standards,
    //   label: 'skills'
    // }
  ];

  const renderTeacherTopicCardData = () => {
    return (
      <>
        <div css={topicRowCss}>
          <TopicMetaRow topics={topicMetaRockMock} />
        </div>
      </>
    );
  };

  const renderStudentTopicCardData = () => {
    return (
      <>
        <div css={challengeDetailCardBadgesContentCss(ACTIVITIES_CONTENT)}>
          <div css={challengeDetailCardBadgesTitleCss}>
            <ChallengesActivityIcon />
            <h5>Activities completed</h5>
          </div>
          <span css={finalScoresCss}>
            {topic?.done_interactions} / {topic?.total_interactions}
          </span>
        </div>
        <ProgressBarTokensCounter
          label="Tokens earned"
          achievedTokens={topic?.earned_tokens}
          totalTokens={topic?.tokens}
          version="DETAILS_CARD_VERSION"
        />
      </>
    );
  };

  const renderTeacherHomeDetailCard = () => {
    return (
      <div css={challengeDetailCardContentCss}>
        <div css={possibleTokensTeacherHome}>
          <PossibleTokens tokens={topic?.tokens} />
        </div>
        <h4 css={challengeDetailCardTitle}>{topic?.title}</h4>
        <div css={metaCss}>
          {topicMetaRockMock.map((meta, index) => {
            return (
              <p key={index} css={metaText}>
                {meta.total} {meta.label}
              </p>
            );
          })}
        </div>
      </div>
    );
  };

  const renderDefaultDetailCard = () => {
    return (
      <>
        <div css={challengeDetailHeaderCss}>
          <Image
            src={topic?.image?.url}
            __css={cardHeaderBackgroundCss}
            alt={`${topic?.image?.alt}`}
          />
          <div css={possibleTokensContainer}>
            <PossibleTokens tokens={topic?.tokens} />
          </div>
        </div>
        <div css={challengeDetailCardContentCss}>
          <h4 css={challengeDetailCardTitle}>{topic?.title}</h4>
          {!isHomeVersion && (
            <LineClamp
              css={descriptionChallengeTextCss}
              lines={2}
              text={descriptionChallengeText}
              innerElement="p"
            />
          )}
          {isTeacher
            ? renderTeacherTopicCardData()
            : renderStudentTopicCardData()}
        </div>
      </>
    );
  };

  return (
    <div
      css={challengeDetailCardCss}
      onClick={() => router.push(`/challenges/${topic.topic_id}`)}
      {...eventProperties}
      data-qa-selector={`IRC: Redirect to Topic Page with topic id ${topic.topic_id}`}
    >
      {isTeacher && isHomeVersion
        ? renderTeacherHomeDetailCard()
        : renderDefaultDetailCard()}
    </div>
  );
};

ChallengeDetailCard.propTypes = propTypes;

export default ChallengeDetailCard;
